import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { LineupStyle } from '@sorare/core/src/components/lobby/ContenderLayout';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import {
  STORAGE,
  useLocalStorage,
} from '@sorare/core/src/hooks/useLocalStorage';

export const usePreferredLineupStyle = (): [
  LineupStyle,
  (value: LineupStyle) => void,
] => {
  const { sport } = useSportContext();

  const [lineupStyle, setLineupStyle] = useLocalStorage<
    Record<Sport, LineupStyle>
  >(STORAGE.sportLineupStyle, {
    [Sport.FOOTBALL]: 'spread',
    [Sport.NBA]: 'spread',
    [Sport.BASEBALL]: 'spread',
  });

  const setSportLineupStyle = (style: LineupStyle) => {
    setLineupStyle({ ...lineupStyle, [sport]: style });
  };

  return [lineupStyle[sport], setSportLineupStyle];
};
